import { IsString, MaxLength } from 'class-validator';

export class CollectiveAgreementRateSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
